// One compiled release scope for web offers and dz-suite system messages. Not authorization.
import scope from './release-scope.json' with { type: 'json' };

export type ReleaseProfile = keyof typeof scope.profiles;
/** Missing or misspelled deployment configuration always keeps the launch boundary. */
export function selectReleaseProfile(value: unknown): ReleaseProfile {
  return value === 'full' ? 'full' : 'launch';
}
const configured = (import.meta as ImportMeta & { env?: { VITE_DUGZI_RELEASE_PROFILE?: string } }).env?.VITE_DUGZI_RELEASE_PROFILE;
export const RELEASE_PROFILE = selectReleaseProfile(configured);

/** Unknown profiles/products hide offers rather than expanding the release. */
export function productAvailable(product: string, profile: string = RELEASE_PROFILE): boolean {
  return Object.hasOwn(scope.profiles, profile)
    && (scope.profiles[profile as ReleaseProfile] as readonly string[]).includes(product);
}
